<template>
    <div>
    <v-simple-table :dense="dt.dense" fixed-header :height="dt.height" class="table-local" :class="{'col-v-top': colVTop,'no-hover': noHover, 'editable': editable, 'checkboxed': dt.checkboxed, 'disabled': dt.model.disabled||disabled}">
        <template v-slot:default>
        <thead class="v-data-table-header" v-if="!dt.hideHeader">
            <tr>
                <th v-if="hasCmd" class="hdr-cmd" :class="cmdHeaderClass">
                    <slot name="header.cmd" :datatable="dt">                        
                        <Checkbox class="mt-0 ml-0" v-if="dt.checkboxed" v-model="dt.stateCheckAll" @click="dt.onFollowCheckAll()"></Checkbox>
                        <span v-else-if="!dt.checkboxed&&dt.canConfigureColumns">

                            <span @click="()=>dt.configure()" class="hdr-cmd cursor-pointer xml-2" >
                                <Icon class="" small type="setting"></Icon>
                            </span>

                        </span>

                    </slot>
                </th>

                <th v-for="(header, i) in columnHeaders" :key="i" :class="clsHeader(header)">
                    <slot :name="columnHeaderName(header)" :datatable="dt">
                        <span v-if="dt.canSort && !header.noSort" class="cursor-pointer" @click="dt.sortBy(header.value)">
                            {{header.text}}
                            <span v-if="header.sort">
                                <i class="v-icon notranslate v-data-table-header__icon fas fa-sort-up theme--light"></i>
                            </span>
                        </span>
                        <span v-else>
                            {{header.text}}
                        </span>
                    </slot>
                </th>
            </tr>
        </thead>
        <tbody v-if="!compItems?.length">
            <tr >
                <td :colspan="dt.headers.length" class="pt-1 no-data-text text-italic text-center text-small">{{dt.noDataText}}</td>
            </tr>
        </tbody>

        <draggable :disabled="!canDrag" v-model="compItems" handle=".draghandle" ghost-class="ghost" animation="200" tag="tbody">            
        <!--
          Can not add a transition-group here as it adds a span element which invalidates the dom table.
        -->
            <template v-for="(item,i) in compItems" >    
                                
                <!--
                Template the row slot if you want to implement the complete row yourselves.
                -->
                <slot name="row" :hasCmd="hasCmd" :index="i" :item="item" :dt="dt" :columnHeaders="columnHeaders">

                    <tr :class="item.selected?'selected':''" :key="i" v-if="!(item.isChild && (item.expanded === false))" @dblclick="(evt)=>dt.onDblClick(evt, item)" @click="(evt)=>dt.onClick(evt, item)" 
                        >        
                    <td v-if="hasCmd" class="col-cmd" >       
                                
                        <Checkbox v-if="!item.noCheckbox && dt.checkboxed" v-model="item.checked"></Checkbox>
                        <slot v-else-if="!item.noMenu && !dt.noMenu" name="item.cmd" :item="item">
                            <IconMenu> 
                                <slot name="menu" :item="item" :datatable="dt"></slot>
                            </IconMenu>
                        </slot>
                        <slot v-else name="menucmd" :item="item" :datatable="dt"></slot>
                    </td>

                    <td v-for="(header, index) in columnHeaders" :key="`ch_${index}_${header.value}`" :class="header.cellClass">
                        <span :class="header.fnClass?(header.fnClass(item[header.value], `${item[header.value]}`.toUpperCase(), item)):header.innerCellClass" :key="`chs_${index}_${header.value}`">
                        <span v-if="header.fmt">
                            <span v-if="header.open">
                                <span class="cursor-pointer primary--text" :color="'primary'" @click="onOpen(header, item)">
                                    {{ header.fmt(item[header.value], `${item[header.value]}`.toUpperCase(), item)}}
                                </span>
                            </span>
                            <span v-else>
                                {{ header.fmt(item[header.value], `${item[header.value]}`.toUpperCase(), item)}}
                            </span>
                        </span>
                        <span v-else-if="header.type=='drag'">                            
                            <Icon class="cursor-move-y" type="drag"></Icon>
                        </span>
                        <span v-else-if="header.type=='amount'">
                            <AmountColumn :value="item[header.value]"></AmountColumn>
                        </span>
                        <span v-else-if="header.type=='date'">
                            <DateTimeText :value="item[header.value]"></DateTimeText>
                        </span>
                        <span v-else-if="header.type=='hhmm'" >
                            <HourMinuteColumn :value="item[header.value]"></HourMinuteColumn>
                        </span>
                        <span v-else-if="header.type=='dhhmm'" >
                            <HourMinuteColumn decimal :value="item[header.value]"></HourMinuteColumn>
                        </span>
                        <span v-else-if="header.type=='datetime'">
                            <DateTimeText time :value="item[header.value]"></DateTimeText>
                        </span>
                        <span v-else-if="header.type=='dow'">
                            <DateTimeText :short="header.short" dow :value="item[header.value]"></DateTimeText>
                        </span>
                        <span v-else-if="header.type=='bool'">
                            <BoolYesNoColumn :check="true" :value="item[header.value]"></BoolYesNoColumn>
                        </span>
                        <span v-else-if="header.open" >
                            <span class="cursor-pointer primary--text" :color="'primary'" @click="onOpen(header, item)">
                                {{ coalesce(item, header.value, header.alternateText) }}
                            </span>
                        </span>

                        <slot v-else :name="columnItemName(header)" :item="item" :datatable="dt">
                            {{item[header.value]}}
                        </slot>
                        </span>
                    </td>
                </tr>
                </slot>
            </template>
        </draggable>  
        <slot name="tfoot" :hasCmd="hasCmd" :dt="dt" :columnHeaders="columnHeaders"></slot>
        <tfoot v-if="dt.showFooter && (!dt.minimalFooterRows || (dt.items && dt.items.length >= dt.minimalFooterRows))">
            <tr>
                <td v-if="hasCmd" class="cmd pl-0 pr-4">
                    <slot name="footer.cmd" :datatable="dt">                        
                    </slot>
                </td>

                <td v-for="(header, i) in columnHeaders" :key="i" :class="header.clsFooter" :style="headerStyle(header)">
                    <slot :name="columnFooterName(header)" :datatable="dt">
                        
                    </slot>
                </td>
            </tr>
        </tfoot>


        </template>
        </v-simple-table>
        
        <slot name="bottom-commands" :hasCmd="hasCmd" :dt="dt" :columnHeaders="columnHeaders"></slot>

        <CommandPane v-if="dt.useCommandPane && dt.checkboxed" :selectedcount="dt.selectedCount" @close="dt.onStopCheckbox()">
            <template v-slot:commands>
                <slot name="commands" :dt="dt" :bulkAction="dt.bulkAction" :selectedCount="dt.selectedCount">
                    <ActionButton main primary icon="remove" v-if="dt.bulkAction=='remove'"  @click="dt.onBulkRemove()" :disabled="!dt.selectedCount" >Verwijder</ActionButton>
                    <ActionButton main primary icon="archive" v-if="dt.bulkAction=='archive'"  @click="dt.onBulkArchive()" :disabled="!dt.selectedCount" >Archiveer</ActionButton>
                    <ActionButton main primary icon="unarchive" v-if="dt.bulkAction=='unarchive'"  @click="dt.onBulkUnArchive()" :disabled="!dt.selectedCount" >Maak actueel</ActionButton>
                    <slot name="customcommands" :bulkAction="dt.bulkAction" :selectedCount="dt.selectedCount">
                    </slot>
                </slot>
            </template>
        </CommandPane> 

    </div>
</template>

<script setup>
    
    import string from '@lib/string'
    import {computed} from 'vue'
    import IconMenu from "@controls/menu/IconMenu.vue";
    import AmountColumn from '@datatable/columns/Amount'
    import Icon from '@controls/icons/Icon'
    import DateTimeText from '@controls/text/DateTime'
    import Checkbox from '@controls/check/Checkbox.vue'
    import CommandPane from '@datatable/components/CommandPane'
    import ActionButton from '@controls/buttons/ActionButton'
    import draggable from 'vuedraggable'
    import dlg from '@app/dlg'
    import HourMinuteColumn from '@datatable/columns/HourMinute'
    import BoolYesNoColumn from '@datatable/columns/BoolYesNo'


    const props = defineProps({
        dt: {
            type: [Object]
        },
        items: {
            type: [Array]
        },
        noHover: {
            type: [Boolean]
        },
        // When specified, the table is draggable. 
        canDrag: {
            type: [Boolean]
        },
        editable: {
            type: [Boolean],
            default: false
        },
        disabled: {
            type: [Boolean],
            default: false
        },
        colVTop: {
            type: [Boolean],
        },
        model: {
            type: [Object]
        },
        modelLinesProp: {
            type: [String]
        }
    })

    var compItems = computed({
        get() {
            var items = [];
            if (props.model && props.modelLinesProp) {
                items = props.model[props.modelLinesProp];
            }

            else if (props.dt.items && props.dt.items.length) {
                items = props.dt.items;
            }
            if (!props.dt.sortColumn) {
                return items;
            }
            var sortedItems = [...(items||[])];
            var fnSort = (l,r)=> {
                var vl = l[props.dt.sortColumn];
                var vr = r[props.dt.sortColumn];
                if (!isNaN(Number(vl)) && !isNaN(Number(vr))) {
                    vl = Number(vl);
                    vr = Number(vr);
                }
                if (vl == vr) {
                    return 0;
                }
                var result = (vl > vr)?1:-1;

                if (props.dt.sortDesc) {
                    result = result * -1;
                }
                return result;
            }
            sortedItems = sortedItems.sort( fnSort );        
            return sortedItems;
        },
        set(value) {
            if (props.model && props.modelLinesProp) {
                props.model[props.modelLinesProp] = value
            }
        }

    })
    function clsHeader(header) {
        if (!header) {
            return "";
        }
        var cls = header?.class || "";
        if (props.dt.canSort) {
            if (header.sort) {
                cls = `${cls} sortable active ${header.sort}`;
            }
        }
        return cls;
    }
    var columnHeaders = computed({
        get() {
            return (props.dt.headers||[]).filter( (header) => header.type != "cmd")
        }
    })
    var hasCmd = computed({
        get() {
            return !!(props.dt.headers||[]).find( (header) => header.type == "cmd")
        }
    })  
    var cmdHeaderClass = computed({
        get() {
            var h = (props.dt.headers||[]).find( (header) => header.type == "cmd");
            if (!h || !h.class) {
                return "";
            }
            return h.class || "";
        }
    })  

    function columnHeaderName(header) {
        return `header.${header.value}`
    }
    function columnFooterName(header) {
        return `footer.${header.value}`
    }
    function columnItemName(header) {
        return `item.${header.value}`
    }
    function coalesce(item, field, alternateText) {
        return string.coalesce(item[field], alternateText);
    }
    function headerStyle(header) {
        let style = header.styleHeader || {};
        if (header.minw) {
            style.width=header.minw;
            style["min-width"]=header.minw;
        }
        if (header.w) { // width can be overridden
            style.width=header.w;
        }
        if (header.maxw) {
            style["max-width"]=header.maxw;
        }
        return style;
    }

    // When an open action is specified, either: 
    // - open the dialog with the item data as parameters
    // - open the dialog and get the parameters from a specified function
    // - call a custom function to open the dialog
    function onOpen(header, item) {
        if (!header.open) {
            return;
        }
        if (typeof(header.open) == 'function') {
            header.open(item, header);
            return;
        }
        var params = item;
        if (header.fnParamsOpen && typeof(header.fnParamsOpen) == 'function') {
            params = header.fnParamsOpen(item);
        }
        dlg.open(header.open, params);
    }

</script>